import type { uk } from "./uk";

export const en: Record<keyof typeof uk, string> = {
  title: "On-device PII redactor",
  tagline: "No text leaves your device. Some entities are determined only after the model runs.",
  skip: "Skip to text",
  navRedactor: "Redactor",
  navMetrics: "Metrics",
  lang: "Language",
  langUk: "UA",
  langEn: "EN",
  theme: "Theme",
  themeLight: "Light",
  themeDark: "Dark",
  themeSystem: "System",
  inputLabel: "Text to scan",
  inputPlaceholder: "Paste a letter, chat, or excerpt. Synthetic samples are the buttons below.",
  samples: "Samples",
  sampleSupport: "Support chat",
  sampleBank: "Payment",
  sampleKyc: "KYC form",
  sampleMixed: "UA / RU / EN",
  sampleNegatives: "Lookalikes",
  previewLabel: "Detected spans",
  emptyPreview: "Highlighted spans will show up here.",
  maskedLabel: "Masked text",
  copy: "Copy",
  copied: "Copied",
  copyFailed: "Copy failed",
  paste: "Paste",
  pasted: "Pasted",
  pasteFailed: "Paste failed",
  maskMode: "Mask mode",
  maskModeHint: "How detected spans are replaced in the masked copy.",
  maskPlaceholder: "Placeholder",
  maskPartial: "Partial",
  maskPseudonym: "Pseudonyms",
  maskPlaceholderHint: "Each span becomes [TYPE], for example [IBAN].",
  maskPartialHint: "Keeps a short tail of the original value.",
  maskPseudonymHint: "Stable labels in this text: RNOKPP_1, PERSON_1…",
  types: "Types",
  typesHint: "Turn a type off to leave it in the masked copy.",
  nerLoadHint: "Downloads ~110 MB from Hugging Face once, then runs on this device.",
  typesAll: "All",
  typesNone: "None",
  entities: "Entities",
  entityType: "Type",
  entityValue: "Value",
  entitySource: "Source",
  entitySpan: "Span",
  sourceRule: "rule",
  sourceModel: "model",
  noEntities: "Nothing found.",
  count: "{n} entities",
  layerRules: "Rules only",
  layerHybrid: "Rules + NER",
  nerIdle:
    "Rules already catch IBAN, cards, tax IDs, phones, passports, UNZR, and email. To find names, enable the Ukrainian NER model (~110 MB, once, cached on this device).",
  nerLoad: "Enable names",
  nerLoading: "Loading the model…",
  nerReady: "Model ready. Names and locations are merged with the rules.",
  nerError: "The model failed to load.",
  nerRetry: "Retry",
  nerRefreshHint: "Hard-refresh the page (Ctrl+Shift+R) and hit Retry. An old tab keeps the previous security policy.",
  tooLong: "Text was trimmed to {n} characters so the tab stays responsive.",
  limitationsTitle: "Limitations",
  limitationsBody:
    "This tool is not a means of ensuring legal or regulatory compliance. Model weights are loaded directly from the Hugging Face Hub, and the input text is processed exclusively in your browser.",
  footerBlurb: "On-device PII redactor. No backend. Text stays in this tab. © 2026",
  footerContact: "Contact:",
  footerGithub: "GitHub",
  metricsTitle: "Held-out metrics",
  metricsLead:
    "Synthetic held-out set, 53 documents, 99 gold spans. The NER threshold was set before this split.",
  metricsLayer: "Layer",
  metricsP: "P",
  metricsR: "R",
  metricsF1: "F1",
  metricsSupport: "N",
  metricsHybrid: "hybrid",
  metricsRules: "rules",
  metricsModel: "model",
  metricsPerType: "Hybrid by type",
  metricsNote:
    "PERSON is almost entirely from the model. Checksum types (IBAN, card, RNOKPP, EDRPOU, UNZR) stay with the rules. ADDRESS F1 dips because the model adds cities while gold marks street patterns.",
  typePERSON: "Person",
  typePHONE: "Phone",
  typeIBAN: "IBAN",
  typeCARD: "Card",
  typeRNOKPP: "RNOKPP",
  typeEDRPOU: "EDRPOU",
  typePASSPORT: "Passport",
  typeUNZR: "UNZR",
  typeEMAIL: "Email",
  typeADDRESS: "Address",
  typeDOB: "Date of birth",
};
